import React from 'react';
import { string, object } from 'yup';
import moment from 'moment';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

const schema = object({
  title: string().required(),
  path: string().required(),
});

const defaults = {
  popup: false,
  popupFreq: 'once',
  frontpage: true,
  title: '',
  coverImg: null,
  content: '',
  path: '',

  publishAt: {
    date: moment().format('YYYY-MM-DD'),
    time: '08:00',
  },
  expiresAt: '',
};

const FormAnnouncement = ({
  announcement: ann,
}) => (
  <FormResource
    {...{
      defaults,
      schema,
      stored: ann ? {
        ...ann,
        publishAt: {
          date: moment(ann.publishAt).format('YYYY-MM-DD'),
          time: moment(ann.publishAt).format('HH:mm'),
        },
        expiresAt: ann.expiresAt
          ? moment(ann.expiresAt).format('YYYY-MM-DD')
          : '',
      } : undefined,
      api: 'api/site/announcements',
      onSubmit: (vs) => ({
        ...vs,
        coverImg: typeof vs.coverImg === 'string'
          ? vs.coverImg : '',
        publishAt: moment(
          `${vs.publishAt.date} ${vs.publishAt.time}`,
          'YYYY-MM-DD HH:mm',
        ).toDate(),
        expiresAt: vs.expiresAt
          ? moment(vs.expiresAt).endOf('d').toDate()
          : null,
      }),
    }}
  >
    <div className="row">
      <div className="col-auto">
        <div className="form-group">
          <label>Show in Frontpage</label>
          <FormCheckGroup
            name="frontpage"
            type="checkbox"
            label=""
            asSwitch
          />
        </div>
        <div className="form-row">
          <div className="col-auto">
            <div className="form-group">
              <label>Popup</label>
              <FormCheckGroup
                name="popup"
                type="checkbox"
                label=""
                asSwitch
              />
            </div>
          </div>
          <div className="col-auto">
            <FormGroup
              className="mt-4"
              name="popupFreq"
              label={null}
              as="select"
            >
              <option value="once">Once</option>
              <option value="everyday">Everyday</option>
            </FormGroup>
          </div>
        </div>
      </div>
      <div className="col">
        <div className="form-row">
          <div className="col">
            <FormGroup name="publishAt.date" type="date" />
          </div>
          <div className="col">
            <FormGroup name="publishAt.time" type="time" label="Time" />
          </div>
        </div>
        <FormGroup name="expiresAt" type="date" />
      </div>
    </div>

    <FormGroup name="title" />
    <FormGroup name="path" as="select">
      <option value=""> - </option>
      <option value="home">home</option>
      <option value="app">app</option>
    </FormGroup>
    <FormGroup
      name="coverImg"
      as="coverImg"
      api={'api/site/view-slots/files'}
    />
    <FormGroup
      name="content"
      as="summernote"
      fileUploadUrl={'api/site/view-slots/files'}
    />
  </FormResource>
);

export default FormAnnouncement;
